module.exports = __webpack_public_path__ + "img/mineIcon2.354e5916.png";